Vue.component('ack-events', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-events',
	mixins: [languageMixins],
	mounted() {
		this.setPageIsLoading(false);
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'events-page',
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
